import {Injectable} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '../../translate.service';
import {HtmlUtilsService} from '../../../html-utils/html-utils.service';
import {MessageService} from '../../../messages/message.service';
import {QueryParams} from '../query-params.model';
import {ListService} from '../list.service';
import {FiltersConfig} from '../../../config/filters/filters-config.model';
import {FiltersService} from '../../../search/search-list/filters/filters.service';
import {AppConfigService} from '../../../config/app-config.service';
import {FilterPortalConfig} from '../../../config/filters/filter-portal-config.model';
import {FilterQueryConfig} from '../../../config/filters/filter-query-config.model';

@Injectable({
  providedIn: 'root'
})
export class FacetService extends FiltersService {

  facetsConfig: FiltersConfig;

  constructor(protected router: Router,
              protected route: ActivatedRoute,
              protected appConfigService: AppConfigService,
              protected translator: TranslateService,
              protected htmlUtils: HtmlUtilsService,
              protected messageService: MessageService,
              protected listService: ListService) {
    super(router, route, appConfigService, translator, htmlUtils, messageService);
  }

  navigateByFilters(remove: boolean = false, search?: boolean) {
    const queryParams = this.createQueryParams(remove, this.filtersToString());
    this.listService.addEvent(queryParams);
  }

  getAggregates(): FilterQueryConfig[] {
    return FiltersService.getAggregate(
      this.facetsConfig.filtersConfig.filter(filter => filter.show));
  }

  protected createQueryParams(remove: boolean = false, filters: string): QueryParams {
    let queryParams = new QueryParams({});
    queryParams.phrase = this.allPhraseFacets.getValue();
    queryParams.page = '1';
    queryParams.searchInText = this.htmlUtils.searchInText;

    let pageSize = this.route.snapshot.queryParamMap.get('pageSize');
    if (pageSize) {
      queryParams.pageSize = pageSize;
    }
    if (filters) {
      queryParams.filters = filters;
    }
    if (!remove) {
      queryParams.sort = this.route.snapshot.queryParamMap.get('sort');
    }
    return queryParams;
  }

  getConfigs(): FilterPortalConfig[] {
    return this.facetsConfig ? this.facetsConfig.filtersConfig : [];
  }
}
